module.exports = __webpack_public_path__ + "static/img/christmas.c1acbdeb.png";